import { motion } from "framer-motion";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../../data/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Contact = () => {
  return (
    <footer id="contact" data-testid="contact-section" className="relative bg-[#0B1120] text-white">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#F5B800] mb-6">Contact</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.05]">
              Let&apos;s build something
              <br />
              <span className="text-[#1C9FD8]">that lasts.</span>
            </h2>
            <p className="mt-8 text-base lg:text-lg text-slate-400 leading-relaxed max-w-md">
              Reach out for consultation, custom development, or to enrol in an upcoming training program.
            </p>
          </div>

          <div className="lg:col-span-6 w-full space-y-4">
            <motion.a
              data-testid="contact-phone"
              href={COMPANY.phoneHref}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="group flex items-center justify-between border border-[#1E293B] hover:border-[#1C9FD8] p-6 transition-colors"
            >
              <span className="flex items-center gap-4">
                <Phone className="w-5 h-5 text-[#1C9FD8]" />
                <span>
                  <span className="block text-xs text-slate-500 tracking-widest uppercase">Call</span>
                  <span className="block text-white font-medium text-lg">{COMPANY.phone}</span>
                </span>
              </span>
              <ArrowUpRight className="w-5 h-5 text-slate-500 group-hover:text-[#F5B800] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
            </motion.a>

            <motion.a
              data-testid="contact-email"
              href={COMPANY.emailHref}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="group flex items-center justify-between border border-[#1E293B] hover:border-[#1C9FD8] p-6 transition-colors"
            >
              <span className="flex items-center gap-4 min-w-0">
                <Mail className="w-5 h-5 shrink-0 text-[#1C9FD8]" />
                <span className="min-w-0">
                  <span className="block text-xs text-slate-500 tracking-widest uppercase">Email</span>
                  <span className="block text-white font-medium text-lg truncate">{COMPANY.email}</span>
                </span>
              </span>
              <ArrowUpRight className="w-5 h-5 shrink-0 text-slate-500 group-hover:text-[#F5B800] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
            </motion.a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#1E293B]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src="/assets/logo.png" alt="TechnoVeda Solutions logo" className="h-9 w-9 object-contain bg-white p-1" />
            <span className="font-display font-bold text-white">{COMPANY.name}</span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                className="text-xs text-slate-400 hover:text-[#1C9FD8] transition-colors tracking-wide"
              >
                {l.label}
              </button>
            ))}
          </div>
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} {COMPANY.name}</p>
        </div>
      </div>
    </footer>
  );
};
